<template>
    <div :class="{'mb-3':!slim}">
        <label class="form-label">{{ label }}</label>
        <div class="d-flex gap-2">
            <input v-for="(digit, index) in digits" :key="index" ref="inputs" type="text" inputmode="numeric"
                   class="form-control text-center fs-4 px-0" :class="{filled: !!digit}" :value="digit"
                   :autocomplete="index === 0 ? 'one-time-code' : 'off'" :disabled="disabled"
                   @input="onInput(index, $event)" @keydown.backspace="onBackspace(index, $event)"
                   @paste.prevent="onPaste(index, $event)" @focus="$event.target.select()">
        </div>
        <p class="form-control-error text-danger" :key="msg" v-for="msg in error">błąd: {{ msg }}</p>
    </div>
</template>

<script>
import control from "@/mixins/control";

export default {
    name: "v-control-code",
    mixins: [control],
    props: {
        length: {type: Number, default: 6},
        autofocus: {type: Boolean, default: false}
    },
    data() {
        return {
            digits: this.split(this.modelValue)
        }
    },
    watch: {
        modelValue(value, previous) {
            if ((value ?? '') !== this.digits.join(''))
                this.digits = this.split(value);

            if (!value && previous)
                this.$nextTick(() => this.focus(0));
        }
    },
    mounted() {
        if (this.autofocus)
            this.focus(0);
    },
    methods: {
        split(value) {
            return Array.from({length: this.length}, (_, index) => (value ?? '')[index] ?? '');
        },
        focus(index) {
            this.$refs.inputs?.[Math.min(index, this.length - 1)]?.focus();
        },
        emit() {
            this.value = this.digits.join('');
        },
        fill(start, text) {
            const digits = text.replace(/\D/g, '').slice(0, this.length - start);

            [...digits].forEach((digit, offset) => {
                this.digits[start + offset] = digit;
            });

            this.emit();
            this.focus(start + digits.length);
        },
        onInput(index, event) {
            const typed = (event.data ?? event.target.value).replace(/\D/g, '');

            if (event.data && !typed) {
                event.target.value = this.digits[index];
                return;
            }

            if (typed.length > 1) {
                this.fill(index, typed);
            } else {
                this.digits[index] = typed;
                this.emit();

                if (typed)
                    this.focus(index + 1);
            }

            event.target.value = this.digits[index];
        },
        onBackspace(index, event) {
            if (this.digits[index] || index === 0)
                return;

            event.preventDefault();
            this.digits[index - 1] = '';
            this.emit();
            this.focus(index - 1);
        },
        onPaste(index, event) {
            this.fill(index, event.clipboardData?.getData('text') ?? '');
        }
    }
}
</script>
